import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const SettingsCard = ({ title, icon, description, onClick, disabled, badge }) => {
  return (
    <div
      className={`settings-card ${disabled ? 'settings-card--disabled' : ''}`}
      onClick={!disabled ? onClick : undefined}
      role="button"
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(e) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
          onClick?.();
        }
      }}
    >
      <div className="settings-card__icon">
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className="settings-card__content">
        <h4 className="settings-card__title">{title}</h4>
        <p className="settings-card__description">{description}</p>
      </div>
      {badge && <span className="settings-card__badge">{badge}</span>}
      <FontAwesomeIcon icon={faChevronRight} className="settings-card__arrow" />
    </div>
  );
};

export default SettingsCard;
